module.exports = __webpack_public_path__ + "static/media/66800015-ovE0wSgs.a8132dae.JPG";